// prettier-ignore
const modalMarkupProfessional = (data) => {
    return `<aside class="modal u-align-left" data-element="edit-user-${data.id}" data-class="modal--active">
    <div class="modal__bg" data-behaviour="modal" data-target="edit-user-${data.id}" >
    </div>
    <div class="modal__body">
        <button class="modal__close" data-behaviour="modal" data-target="edit-user-${data.id}">
            <span class="sr-only">close modal</span>
            <svg width="44" height="44" class="modal__svg-close">
                <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#close"></use>
            </svg>
        </button>
        <form action="#" data-behaviour="form-post" data-endpoint="/api/rec/membership/professional/members/edit/" class="form">
            <input type="text" class="u-hidden" name="id" value="${data.id}">
            <fieldset class="fieldset fieldset--plain">
                <div class="sr-only">Edit user ${data.firstName}</div>
                <div class="fieldset__header">
                    <h2 class="heading--4">Edit user ${data.firstName}</h2>
                </div>
                <div class="js-validate-group u-mb">
                    <label class="label" for="user-edit-${data.id}-first-name">First name</label>
                    <input type="text" class="input" id="user-edit-${data.id}-first-name" value="${data.firstName}" name="firstName">
                </div>
                <div class="js-validate-group u-mb">
                    <label class="label" for="user-edit-${data.id}-last-name">Last name</label>
                    <input type="text" class="input" id="user-edit-${data.id}-last-name" value="${data.lastName}" name="lastName">
                </div>
                <div class="js-validate-group u-mb">
                    <label class="label" for="user-edit-${data.id}-email">Email</label>
                    <input type="email" class="input" id="user-edit-${data.id}-email" value="${data.email !== null ? data.email : ''}" name="email">
                </div>
            </fieldset>
            <button class="button button--cornflower" type="submit">Save and close</button>
            <div class="form__response" data-element="response-container" ></div>
        </form>
    </div>
</aside>`
}

// prettier-ignore
const modalMarkupCorporate = (data) => {
    let financeChecked = ''
    if (data.financeContactAssignee === data.firstName + ' ' + data.lastName) {
        financeChecked = 'checked'
    } else {
        financeChecked = ''
    }
    return `<aside class="modal u-align-left" data-element="edit-user-${data.id}" data-class="modal--active">
    <div class="modal__bg" data-behaviour="modal" data-target="edit-user-${data.id}" >
    </div>
    <div class="modal__body">
        <button class="modal__close" data-behaviour="modal" data-target="edit-user-${data.id}">
            <span class="sr-only">close modal</span>
            <svg width="44" height="44" class="modal__svg-close">
                <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#close"></use>
            </svg>
        </button>
        <form action="#" data-behaviour="form-post" data-endpoint="/api/rec/membership/corporate/members/edit/" class="form">
            <input type="text" class="u-hidden" name="id" value="${data.id}">
            <fieldset class="fieldset fieldset--plain u-mb0">
                <div class="sr-only">Edit user ${data.firstName}</div>
                <div class="fieldset__header">
                    <h2 class="heading--4">Edit user ${data.firstName}</h2>
                </div>
                <div class="js-validate-group u-mb">
                    <label class="label" for="user-edit-${data.id}-first-name">First name</label>
                    <input type="text" class="input" id="user-edit-${data.id}-first-name" value="${data.firstName}" name="firstName">
                </div>
                <div class="js-validate-group u-mb">
                    <label class="label" for="user-edit-${data.id}-last-name">Last name</label>
                    <input type="text" class="input" id="user-edit-${data.id}-last-name" value="${data.lastName}" name="lastName">
                </div>
                <div class="js-validate-group u-mb">
                    <label class="label" for="user-edit-${data.id}-email">Email</label>
                    <input type="email" class="input" id="user-edit-${data.id}-email" value="${data.email !== null ? data.email : ''}" name="email">
                </div>
                <div class="js-validate-group u-mb">
                    <label class="label" for="user-edit-${data.id}-job-title">Job title</label>
                    <input type="text" class="input" id="user-edit-${data.id}-job-title" value="${data.jobTitle !== null ? data.jobTitle : ''}" name="jobTitle">
                </div>
            </fieldset>
            <div class="hr">
                <hr class="hr__inner">
            </div>
            <fieldset class="fieldset fieldset--plain ">
                <div class="sr-only">User roles</div>
                <div class="fieldset__header">
                    <h2 class="heading--4">User roles</h2>
                    <div class="toggle toggle--with-tooltip">
                        <input type="checkbox" class="toggle__input" id="user-edit-${data.id}-legal-helpline-access" name="legalHelplineAccess"
                        ${data.legalHelplineAccess === true ? 'checked' : ''}>
                        <label class="toggle__label" for="user-edit-${data.id}-legal-helpline-access">Legal helpline access</label>
                        <div class="tooltip">
                            <button class="tooltip__button" type="button" data-behaviour="tooltip" data-target="tooltip-legal">
                                <svg width="20" height="20" class="tooltip__icon">
                                    <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#tooltip"></use>
                                </svg>
                                <span class="sr-only">toggle tooltip window</span>
                            </button>
                            <aside class="tooltip__window wysiwyg" data-element="tooltip-legal" data-class="tooltip__window--active">
                                REC Corporate Members may nominate staff to have access to the REC Legal Helpline. There is no restriction on the number of staff you can nominate.
                            </aside>
                        </div>
                    </div>
                </div>
                <div class="u-mb-half">
                    <strong>Compliance contact</strong>
                    <div class="tooltip">
                        <button class="tooltip__button" type="button" data-behaviour="tooltip" data-target="tooltip-1">
                            <svg width="20" height="20" class="tooltip__icon">
                                <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#tooltip"></use>
                            </svg>
                            <span class="sr-only">toggle tooltip window</span>
                        </button>
                        <aside class="tooltip__window wysiwyg" data-element="tooltip-1" data-class="tooltip__window--active">
                            Each REC Corporate Member must nominate one person within their company to be our Compliance Contact. This person is responsible for taking the REC’s Compliance Test.
                        </aside>
                    </div>
                </div>
                <div class="js-validate-group u-mb-half">
                    <div class="checkbox">
                        <p>Assigned to: ${data.complianceContactAssignee !== null ? data.complianceContactAssignee : 'Currently unassigned'}</p>
                        <input type="checkbox" class="checkbox__input ${data.complianceContact === true ? 'u-hidden' : ''}" id="edit-user-${data.id}-compliance-contact" name="complianceContact" ${data.complianceContact === true ? 'checked' : ''}>
                        <label for="edit-user-${data.id}-compliance-contact" class="checkbox__label  ${data.complianceContact === true ? 'u-hidden' : ''}">Assign to user</label>
                    </div>
                </div>
                <div class="u-mb-half">
                    <strong>Learning and development</strong>

                    <div class="tooltip">
                        <button class="tooltip__button" type="button" data-behaviour="tooltip" data-target="tooltip-learning">
                            <svg width="20" height="20" class="tooltip__icon">
                                <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#tooltip"></use>
                            </svg>
                            <span class="sr-only">toggle tooltip window</span>
                        </button>
                        <aside class="tooltip__window wysiwyg" data-element="tooltip-learning" data-class="tooltip__window--active">
                            Each REC Corporate Member must nominate one person within their company to be our Learning and Development Contact. This person will have access to the training and qualification records of their staff.
                        </aside>
                    </div>
                </div>
                <div class="js-validate-group">
                    <div class="checkbox u-mb0">
                        <p>Assigned to: ${data.learningDevelopmentAssignee !== null ? data.learningDevelopmentAssignee : 'Currently unassigned'}</p>
                        <input type="checkbox" class="checkbox__input ${data.learningAndDevelopment === true ? 'u-hidden' : ''}" id="edit-user-${data.id}-learning-and-development" name="learningAndDevelopment" ${data.learningDevelopment === true ? 'checked' : ''}>
                        <label for="edit-user-${data.id}-learning-and-development" class="checkbox__label ${data.learningAndDevelopment === true ? 'u-hidden' : ''}">Assign to user</label>
                    </div>
                </div><div class="u-mb-half">
                    <strong>Finance contact</strong>

                    <div class="tooltip">
                        <button class="tooltip__button" type="button" data-behaviour="tooltip" data-target="tooltip-finance">
                            <svg width="20" height="20" class="tooltip__icon">
                                <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#tooltip"></use>
                            </svg>
                            <span class="sr-only">toggle tooltip window</span>
                        </button>
                        <aside class="tooltip__window wysiwyg" data-element="tooltip-finance" data-class="tooltip__window--active">
                            Each REC Corporate Member must nominate one person within their company to be our Finance Contact. This person is able to process subscription renewal, and can access invoices. This person is able to process subscription renewal, and can access invoices.
                        </aside>
                    </div>
                </div>
                <div class="js-validate-group u-mb-half">
                    <div class="checkbox">
                        <p>Assigned to: ${data.financeContactAssignee !== null ? data.financeContactAssignee : 'Currently unassigned'}</p>
                        <input type="checkbox" class="checkbox__input ${financeChecked === 'checked' ? 'u-hidden' : ''}" id="edit-user-${data.id}-finance-contact" name="financeContact" ${financeChecked}>
                        <label for="edit-user-${data.id}-finance-contact" class="checkbox__label ${financeChecked === 'checked' ? 'u-hidden' : ''}">Assign to user</label>
                    </div>
                </div>
            </fieldset>
            <button class="button button--cornflower" type="submit">Save and close</button>
            <div class="form__response" data-element="response-container" ></div>
        </form>
    </div>
</aside>
`
}

// prettier-ignore
const legalHelplineIcon = (data) => {
    if (data.legalHelplineAccess === true || data.legalHelplineAccess === false) {
        return `<td class="table__body-cell u-align-center@min-medium">
        <strong class="u-hidden@min-medium">Legal helpline access:</strong>
            ${(data.legalHelplineAccess === true) ? `<svg width="20" height="20" class="u-fill-aquamarine">
                <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#success"></use>
            </svg>
            <span class="sr-only">has legal helpline access</span>` : ''}
        </td>`
    } else {
        return ''
    }
}

// prettier-ignore
const variableColumn = (data) => {
    if (data.type === 'corporate') {
        return `<td class="table__body-cell"><strong class="u-hidden@min-medium">§:</strong> ${data.userRole !== null ? data.userRole : ''}</td>`
    } else if (data.type === 'professional') {
        return `<td class="table__body-cell"><strong class="u-hidden@min-medium">Membership:</strong> ${data.membership !== null ? data.membership : ''}</td>`
    }
    return ''
}

// prettier-ignore
const template = (data) => `
<tr class="table__body-row">
    <th class="table__head-cell u-hidden@min-medium u-df grid--justify-space-between">
        ${data.firstName} ${data.lastName}
    </th>
    <td class="table__body-cell u-hidden@medium">${data.lastName}</td>
    <td class="table__body-cell u-hidden@medium">${data.firstName}</td>
    <td class="table__body-cell"><strong class="u-hidden@min-medium">Email:</strong> ${data.email !== null ? data.email : ''}</td>
    ${variableColumn(data)}
    ${legalHelplineIcon(data)}
    <td class="table__body-cell table__body-cell-last u-align-center@min-medium">
        <button class="button-link u-color-cornflower" data-behaviour="modal" data-target="edit-user-${data.id}"  data-hash="edit-user-${data.id}" >Edit</button>
        ${data.type === 'corporate' ? modalMarkupCorporate(data) : modalMarkupProfessional(data)}
    </td>
    <td class="table__body-cell u-align-center">
        <div class="checkbox table__checkbox">
            <input type="checkbox" class="checkbox__input" id="user-select-${data.id}-first-last" data-element="checkbox" data-behaviour="delete-checkbox" value="${data.id}">
            <label for="user-select-${data.id}-first-last" class="checkbox__label"><span class="sr-only">${data.firstName} ${data.lastName}</span></label>
        </div>
    </td>
</tr>
`
export default template
